import { Users, Flag, Grid2x2Plus, Copy, AlignLeft, Plus, Pencil, Trash2, Box, Info, Play, Undo, Globe, Layers, Component } from 'lucide-react';

export default {
  users: Users,
  flag: Flag,
  components: Grid2x2Plus,
  pages: Copy,
  text: AlignLeft,
  plus: Plus,
  pencil: Pencil,
  bin: Trash2,
  box: Box,
  info: Info,
  play: Play,
  undo: Undo,
  globe: Globe,
  system: Layers,
  cms: Component,
};
